import React from "react";
import './index.css';
import { toast, Toaster } from 'react-hot-toast';
import copy from 'copy-to-clipboard';
import {useTranslation} from "react-i18next";

const ContactUs = () => {
  const linkToCopy = "ordermulti@outlook.com";
  const { t } = useTranslation();
  const handleCopy = () => {
    copy(linkToCopy); // 使用copy-to-clipboard库来复制链接
    toast.success(t('mailCopySuccess')); // 使用react-hot-toast来显示成功提示
  };

  return (
    <div className="banner">
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
      <div className="content">
        <h1>{t('customerService')}</h1>
        <div>{t('wechat')}：</div>
        <h3 className="my-h3">
          <div className="qrcode-container">
            <img src="./contact/customer.png"/>
              <div className="des">
                <span className="wechat-logo"><img src="./contact/wechat-logo.png"/></span>{t("wechatDes")}
              </div>
          </div>
        </h3>
        <p>{t("contactMail")}：<a href="mailto:ordermulti@outlook.com?subject=Order%20Multi" onClick={handleCopy}>ordermulti@outlook.com</a></p>
        <p>{t('contactPhone')}：+8615810821028</p>
        <p>{t("qqNum")}：648866726</p>
        <br/>
        <p>{t('invest')}</p>
        {/*<br/><br/><br/>*/}
      </div>
    </div>
  );
};

export default ContactUs;
